import { render, staticRenderFns } from "./SubTypes.vue?vue&type=template&id=34c23df0"
import script from "./SubTypes.vue?vue&type=script&lang=js"
export * from "./SubTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports